import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { addRecentlyViewedProduct } from '~/utils/recentlyViewedProducts';

interface RecentlyViewedProductParams {
  id?: string;
  label?: string;
  href?: string;
  productLabel?: string;
  enabled?: boolean;
}

export default function useRecentlyViewedProduct({
  id,
  label,
  href,
  productLabel,
  enabled = true,
}: RecentlyViewedProductParams) {
  const location = useLocation();
  const currentHref = href ?? `${location.pathname}${location.search}${location.hash}`;

  useEffect(() => {
    if (!enabled || !id || !label || !productLabel) {
      return;
    }

    addRecentlyViewedProduct({
      id,
      label,
      href: currentHref,
      productLabel,
    });
  }, [currentHref, enabled, id, label, productLabel]);
}
